import { FC } from 'react';
import { Form, Table } from 'antd';
import { FileSearchOutlined } from '@ant-design/icons';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import FleetTitle from '@/libs/antd/components/Title';
import { OfficeObservationPhoto } from '@/libs/fleet-api/services/types';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';
import { useModals } from '@/components/modals/ModalProvider';
import { FleetFile } from '@/libs/fleet-api/fetcher';

type OfficeObservationPhotoPayload = OfficeObservationPhoto<'payload'> &
	Pick<OfficeObservationPhoto, 'photo'>;

type VisitReportPhotoForm = {
	lists: OfficeObservationPhotoPayload[];
};

const FBDHVisitReportPhoto: FC = () => {
	const { openPreviewModal } = useModals();
	const { officeObservation } = useFBDHVisitReportApprovalPage();
	const { technicalAspect } = officeObservation ?? {};
	const { form, fieldName } = useForm<VisitReportPhotoForm>();

	return (
		<Form.Provider>
			<FleetTitle>Foto Survey Kantor</FleetTitle>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				initialValues={
					{
						lists:
							technicalAspect?.photos?.map((photo) => {
								return {
									id: photo.id,
									description: photo.description,
									name: photo.name,
									photo: {
										id: photo.photo.id,
										name: photo.photo.name,
										path: photo.photo.path,
										url: photo.photo.url,
									},
								};
							}) ?? [],
					} as VisitReportPhotoForm
				}
				style={{ marginBottom: 30 }}
			>
				<Form.Item
					name={fieldName(['lists'])}
					noStyle
				/>
				<Form.Item shouldUpdate>
					{({ getFieldsValue }) => {
						const values = getFieldsValue() as VisitReportPhotoForm;
						const dataSource =
							values?.lists?.map((list, key?) => {
								return { ...list, key };
							}) ?? [];

						return (
							<Table
								bordered
								pagination={false}
								dataSource={dataSource}
								columns={[
									{
										title: 'View Photo',
										render: (_, { photo }) => {
											return (
												<a
													href="#"
													onClick={(e) => {
														e.preventDefault();
														if (!photo) return;
														openPreviewModal(photo as unknown as FleetFile);
													}}
												>
													<FileSearchOutlined />
												</a>
											);
										},
										width: 110,
										align: 'center',
									},
									{
										title: 'Nama Foto',
										render: (_, record) => record.name ?? '-',
									},
									{
										title: 'Deskripsi',
										render: (_, record) => record.description ?? '-',
									},
								]}
							/>
						);
					}}
				</Form.Item>
			</Form>
		</Form.Provider>
	);
};

export default FBDHVisitReportPhoto;
